import PropTypes from "prop-types"
import React, { useEffect, useRef } from "react"

// //Import Scrollbar
import SimpleBar from "simplebar-react"

import { withRouter } from "react-router-dom"
import { Link, NavLink } from "react-router-dom"
import { authProtectedRoutes } from "../../routes/AppRoutes"
import MetisMenu from "@metismenu/react"
import "./styles.css"

const SidebarContent = props => {
  const ref = useRef()

  const currentUser = props.currentUser

  useEffect(() => {
    const pathName = props.location.pathname

    const initMenu = () => {
      let matchingMenuItem = null
      const ul = document.getElementsByClassName("metismenu")[0]
      if (ul) {
        const items = ul.getElementsByTagName("a")
        for (let i = 0; i < items.length; ++i) {
          if (pathName === items[i].pathname) {
            matchingMenuItem = items[i]
            break
          }
        }
        if (matchingMenuItem) {
          activateParentDropdown(matchingMenuItem)
        }
      }
    }
    initMenu()
  }, [props.location.pathname])

  useEffect(() => {
    ref.current.recalculate()
  })

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  function activateParentDropdown(item) {
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      scrollElement(item)
      return false
    }
    scrollElement(item)
    return false
  }

  function getSubMenuNodes(menuItem) {
    let subMenuNodes = []
    let userPermissions =
      currentUser.permissions && currentUser.permissions.length > 0
        ? currentUser.permissions
        : []
    let subMenuNode = menuItem
    if (subMenuNode.showInSidebar) {
      subMenuNodes.push(
        <li className="blue-color" key={subMenuNode.key}>
          <NavLink exact to={subMenuNode.path} target="_self">
            <span style={{ color: "white" }}>{subMenuNode.title}</span>
          </NavLink>
        </li>
      )
    }
    // for (let subMenuNode of menuItem.childRoutes) {
    // if (
    //   subMenuNode.showInSidebar &&
    //   subMenuNode.permissions &&
    //   subMenuNode.permissions.includes(currentUser.permissions)
    // ) {
    //   subMenuNodes.push(
    //     <li className="blue-color" key={subMenuNode.key}>
    //       <Link to={subMenuNode.path} target="_self">
    //         <span>{subMenuNode.title}</span>
    //       </Link>
    //     </li>
    //   )
    // } else {
    //   for (let userPermission of userPermissions) {
    //     if (
    //       subMenuNode.showInSidebar &&
    //       subMenuNode.permissions &&
    //       subMenuNode.permissions.includes(userPermission)
    //     ) {
    //       subMenuNodes.push(
    //         <li className="blue-color" key={subMenuNode.key}>
    //           <NavLink exact to={subMenuNode.path} target="_self">
    //             <span>{subMenuNode.title}</span>
    //           </NavLink>
    //         </li>
    //       )
    //       break
    //     }
    //   }
    // }
    // }
    return subMenuNodes
  }

  function getMenuNode(menuItem) {
    // if (menuItem.childRoutes && menuItem.childRoutes.length > 0) {
    let subMenuNodes = getSubMenuNodes(menuItem)
    if (subMenuNodes.length > 0) {
      return (
        //     <ul
        //     key={menuItem.key + "submenu"}
        //     className="sub-menu"
        //     aria-expanded="false"
        //   >
        <span>{subMenuNodes.map(subMenuNode => subMenuNode)}</span>
        //   </ul>
      )
    } else {
      return null
    }
  }

  function getMenuItems() {
    let menuItems = []
    authProtectedRoutes.sort((menu, next_menu) => {
      if (menu.title < next_menu.title) {
        return -1
      }
      if (menu.title > next_menu.title) {
        return 1
      }
      return 0
    })
    authProtectedRoutes.map(menuItem => {
      let menuNode = getMenuNode(menuItem)
      if (menuNode) {
        menuItems.push(menuNode)
      }
    })
    return menuItems
  }
  if (currentUser) {
    return (
      <React.Fragment>
        <SimpleBar className="h-100" ref={ref}>
          <div id="sidebar-menu" className="rm-bg-color">
            <MetisMenu id="side-menu" className="list-unstyled">
              {getMenuItems().map(menuItem => menuItem)}
            </MetisMenu>
          </div>
        </SimpleBar>
      </React.Fragment>
    )
  }
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(SidebarContent)
